// VendorProfilePage.js
import React, { useEffect, useState } from "react";
import PageContainer from "../../components/PageContainer";
import MainContent from "../../components/MainContent";
import PageTitle from "../../components/Common/PageTitle/PageTitle";
import VendorProfile from "../../components/Vendor/VendorProfile";
import VendorAccounts from "../../components/Vendor/VendorAccounts";
import VendorTransactions from "../../components/Vendor/VendorTransactions";
import CardTileA from "../../components/Common/CardTileA";
import { useNavigate } from "react-router-dom";
import { useVendor } from "../../DataStore/VendorContext";
import ajaxPayee from "../../util/remote/ajaxPayee";
import functions from "../../util/functions";
import Pagination from "../../components/Common/Pagination";
import { useVendorStatement } from "../../DataStore/VendorStatementContext";

const VendorProfilePage = () => {
  const navigate = useNavigate();
  const { selectedVendor } = useVendor();

  const [transCount, setTransCount] = useState("...");
  const [currentPage, setCurrentPage] = useState(1);
  const [metaData, setMetaData] = useState(null);
  const [transactions, setTransactions] = useState(null);
  const [accounts, setAccounts] = useState(null);

  const { dispatch, accountInfo } = useVendorStatement();
  const [showStatement, setShowStatement] = useState(false);

  useEffect(() => {
    if (!selectedVendor) navigate("/");
  }, [selectedVendor]);

  useEffect(() => {
    if (!selectedVendor) return;
    getTransCount();
    getAccounts();
  }, [selectedVendor]);

  useEffect(() => {
    if (!selectedVendor) return;
    getTransactions();
  }, [currentPage, selectedVendor]);

  useEffect(() => {
    if (accountInfo && showStatement) navigate("/vendor-statement");
  }, [accountInfo, selectedVendor, showStatement]);

  const getTransCount = async () => {
    const server_response = await ajaxPayee.fetchPayeeTransCount(
      selectedVendor.payee_id
    );
    if (server_response.status === "OK") setTransCount(server_response.details);
    else setTransCount("00");
  };

  const getTransactions = async () => {
    const server_response = await ajaxPayee.fetchPayeeTransactions({
      payee_id: selectedVendor.payee_id,
      page: currentPage,
    });
    if (server_response.status === "OK") {
      setTransactions(server_response.details.data);
      setMetaData(server_response.details.meta);
    } else {
      setTransactions("404");
      setMetaData(null);
    }
  };

  const getAccounts = async () => {
    const server_response = await ajaxPayee.fetchPayeeTransAccounts(
      selectedVendor.payee_id
    );
    if (server_response.status === "OK") setAccounts(server_response.details);
    else setAccounts("404");
  };

  const handleStatement = (account) => {
    dispatch({ type: "accountInfo", payload: account });
    setShowStatement(true);
  };

  return (
    <PageContainer>
      <MainContent>
        <PageTitle
          title={`Vendor: ${selectedVendor?.title || ""}`}
          description="Explore detailed insights about the vendor's transactions and accounts."
          iconClass="fa fa-truck"
          Pagination={
            metaData ? (
              <Pagination
                metaData={metaData}
                onPageChange={(page) => setCurrentPage(page)}
              />
            ) : (
              <></>
            )
          }
        />

        {/* TOP GRID: make both columns the same height */}
        <div className="row align-items-stretch">
          {/* Left column: stretch + force card to fill height */}
          <div className="col-lg-4">
              <VendorProfile vendorData={selectedVendor} />
          </div>

          {/* Right column: tiles + accounts should fill the remaining height */}
          <div className="col-lg-8">
              <div className="row">
                <div className="col-md-4">
                  <CardTileA
                    title="Invoices Recievables"
                    value={"00"}
                    cardIcon="fa fa-arrow-up text-success"
                    cardIconClass="text-success"
                    preText="Ugx"
                    borderColorClass={"success"}
                  />
                </div>

                <div className="col-md-4">
                  <CardTileA
                    title="Invoices Payables"
                    value={"00"}
                    cardIcon="fa fa-arrow-down text-danger"
                    cardIconClass="text-danger"
                    preText="Ugx"
                    borderColorClass={"danger"}
                  />
                </div>

                <div className="col-md-4">
                  <CardTileA
                    title="Transaction Count"
                    value={functions.numberFormat(transCount)}
                    cardIcon="fa fa-star"
                    cardIconClass="text-warning"
                    preText=""
                    borderColorClass={"primary"}
                  />
                </div>
              </div>

                <div className="row mt-4">
                  <div className="col-12">
                  <VendorAccounts
                    accounts={accounts}
                    handleStatement={handleStatement}
                  />
                  </div>
                </div>
            </div>
        </div>

        {/* TRANSACTION HISTORY: full width */}
        <div className="row">
          <div className="col-12">
            <VendorTransactions transactions={transactions} />
          </div>
        </div>
      </MainContent>
    </PageContainer>
  );
};

export default VendorProfilePage;
